<template>
  <div>
    <template v-if="modificationType === 1">
      <div style="margin-top:40px">
        <el-form
          ref="passwordForm"
          label-position="right"
          label-width="120px"
          :model="passwordForm"
          :rules="rules"
        >
          <el-form-item label="原登录密码" prop="originalPassWd">
            <el-input
              autocomplete="new-password"
              onfocus="this.type='password'"
              v-model="passwordForm.originalPassWd"
            ></el-input>
          </el-form-item>
          <el-form-item label="新登录密码" prop="newPassWdOne">
            <el-input
              placeholder="请输入8-16位字母或数字组合"
              autocomplete="new-password"
              onfocus="this.type='password'"
              v-model="passwordForm.newPassWdOne"
            ></el-input>
          </el-form-item>
          <el-form-item label="二次输入密码" prop="newPassWdSecond">
            <el-input
              placeholder="请输入8-16位字母或数字组合"
              autocomplete="new-password"
              onfocus="this.type='password'"
              v-model="passwordForm.newPassWdSecond"
            ></el-input>
          </el-form-item>
          <el-form-item label="经办人手机号" prop="phone">
            <el-input disabled v-model="passwordForm.phone"></el-input>
          </el-form-item>
          <el-form-item label="验证码" prop="verifyCode">
            <div style="display:flex">
              <el-input
                placeholder="请输入验证码"
                v-model="passwordForm.verifyCode"
              ></el-input>
              <XrkSlideVerify
                ref="verification"
                :options="verificationOptions"
                @success="checkSuccessful"
                @close="verifyClose"
              >
                <el-button
                  type="primary"
                  class="login-bts2"
                  @click="showVerification"
                  :disabled="sendLock"
                  :loading="ifBtnLoad"
                >
                  {{ sendText }}
                </el-button>
              </XrkSlideVerify>
            </div>
          </el-form-item>
        </el-form>
        <div style="text-align:center;margin:20px 0 30px 0">
          <el-button @click="submitModification(0)">取消</el-button>
          <el-button @click="submitModification(1)" type="primary">
            确认
          </el-button>
        </div>
      </div>
    </template>
    <template v-if="modificationType === 2">
      <div style="margin-top:40px">
        <el-form
          ref="authPeopleForm"
          label-position="right"
          label-width="150px"
          :model="authPeopleForm"
          :rules="rules"
        >
          <el-form-item label="原经办人" prop="originalAuthPeople">
            <el-input
              disabled
              v-model="authPeopleForm.originalAuthPeople"
            ></el-input>
          </el-form-item>
          <el-form-item label="新经办人" prop="newAuthPeople">
            <el-input v-model="authPeopleForm.newAuthPeople"></el-input>
          </el-form-item>
          <el-form-item label="新经办人身份证号码" prop="id">
            <el-input v-model="authPeopleForm.id"></el-input>
          </el-form-item>
          <el-form-item label="新经办人手机号" prop="phone">
            <el-input v-model="authPeopleForm.phone"></el-input>
          </el-form-item>
          <el-form-item label="验证码" prop="verifyCode">
            <div style="display:flex">
              <el-input v-model="authPeopleForm.verifyCode"></el-input>
              <XrkSlideVerify
                ref="verification"
                :options="verificationOptions"
                @success="checkSuccessful"
                @close="verifyClose"
              >
                <el-button
                  type="primary"
                  class="login-bts2"
                  @click="showVerification"
                  :disabled="sendLock"
                  :loading="ifBtnLoad"
                >
                  {{ sendText }}
                </el-button>
              </XrkSlideVerify>
            </div>
          </el-form-item>
        </el-form>
        <div style="font-size:12px;color:#999999;text-align:center">
          重新认证经办人将会重新进行经办人实名认证以及企业认证。请您确认后再修改。
        </div>
        <div style="text-align:center;margin:20px 0 30px 0">
          <el-button @click="submitModification(0)">取消</el-button>
          <el-button @click="submitModification(1)" type="primary">
            确认
          </el-button>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { accountManagement } from '@/api/ajax';
import { logout } from '@/api/ajax';

export default {
  props: {
    modificationType: {
      type: Number,
      require: true
    },
    phone: {
      type: String,
      require: true
    },
    authPeople: {
      type: String,
      require: true
    }
  },
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== this.passwordForm.newPassWdOne) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };
    return {
      rules: {
        originalPassWd: [
          { required: true, message: '请输入密码', trigger: 'blur' }
        ],
        newPassWdOne: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          {
            min: 8,
            max: 16,
            message: '请输入8-16位字母或数字组合',
            trigger: 'blur'
          }
        ],
        newAuthPeople: [
          { required: true, message: '请输入新经办人', trigger: 'blur' }
        ],
        id: [{ required: true, message: '请输入身份证号', trigger: 'blur' }],
        phone: [
          { required: true, message: '请输手机号码', trigger: 'blur' },
          // { type: 'number', message: '请输入有效的手机号', trigger: 'blur' },
          {
            min: 11,
            max: 11,
            message: '请输入有效的手机号',
            trigger: 'blur'
          }
        ],
        newPassWdSecond: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          {
            min: 8,
            max: 16,
            message: '请输入8-16位字母或数字组合',
            trigger: 'blur'
          },
          {
            validator: validatePass,
            trigger: 'blur'
          }
        ],
        verifyCode: [
          // {
          //   required: true,
          //   message: '请输入验证码',
          //   trigger: 'blur'
          // }
        ]
      },
      sendLock: false,
      ifBtnLoad: false,
      sendText: '获取验证码',
      verificationOptions: {
        // 接口请求 防抖
        remoteTimerInterval: 800,
        errorText: '请控制拼图块对齐缺口',
        successText: '验证成功',
        remoteApi: {
          initImages: accountManagement.getVerification,
          checkVerification: position => {
            return accountManagement.sendMessageCodeForUpdatePwd({
              ...(this.modificationType === 1
                ? this.passwordForm
                : this.authPeopleForm),
              ...position
            });
          }
        },
        errorAnimationDuration: 800
      },
      authPeopleForm: {},
      passwordForm: {
        originalPassWd: '',
        newPassWdOne: '',
        newPassWdSecond: '',
        phone: '',
        verifyCode: ''
      },
      imgUrl: ''
    };
  },
  mounted() {
    this.formInit();
  },
  methods: {
    submitModification(type) {
      if (!type) {
        this.$xrkDialog.remove();
        return;
      } else {
        if (this.passwordForm.verifyCode === '') {
          this.$message.error('请输入验证码');
          return;
        }
        accountManagement
          .masterAccountEditPassWD(this.passwordForm)
          .then(params => {
            if (params.data.status != 1) {
              this.$message.error(params.data.message);
            } else {
              this.$message.success(params.data.message);
              this.$xrkDialog.remove();
              this.logout();
            }
          });
      }
    },
    async logout() {
      //退出
      await logout();
      localStorage.clear();
      sessionStorage.clear();
      this.$store.commit('SET_MENUS', []);
      this.$store.commit('SET_ACCESS_PROJECT', []);
      location.reload();
    },
    checkSuccessful() {
      this.timer = setInterval(() => {
        if (this.sendText > 0) {
          this.sendText -= 1;
        } else {
          clearInterval(this.timer);
          this.sendText = '获取验证码';
          this.sendLock = false;
        }
      }, 1000);
    },
    formInit() {
      this.authPeopleForm.authPeople = this.authPeople;
      this.passwordForm.phone = this.phone;
      this.imgUrl = `${accountManagement.verifyImgCode}?phone=${
        this.passwordForm.phone
      }&v=${+new Date()}`;
    },
    verifyClose() {
      clearInterval(this.timer);
      this.sendText = '获取验证码';
      this.sendLock = false;
    },
    closeProtocol() {
      this.showProtocol = false;
    },
    showVerification() {
      this.checkVerify = false;
      if (!this.sendLock) {
        this.$refs['passwordForm'].validate(valid => {
          if (!valid) return;
          this.sendLock = true;
          this.sendText = 60;
          this.$refs['verification'].visible = true;
        });
      }
    }
  }
};
</script>

<style></style>
